import React, { useState } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './itemQuantity.scss';

const ItemQuantity = ({item,currentQuantity, updateQuantity}) => {
  const increase  = () => {
    const q = item.orderItem.quantity + 1;
    updateQuantity(q);
    item.orderItem.quantity = q;

  };

  const decrease  = () => {
    const currentQuantity = item.orderItem.quantity;
    const q = (currentQuantity - 1) <= 0 ? 1 : currentQuantity - 1;
    updateQuantity(q);
    item.orderItem.quantity = q;
  };

  return (
    <div className="item-quantity-block">
      <div className="decrease-block" onClick={ decrease }>
        <FontAwesomeIcon icon="minus-circle"  />
      </div>
      <div className="quantity-number">
        { currentQuantity }
      </div>
      <div className="increase-block" onClick={ increase }>
        <FontAwesomeIcon icon="plus-circle"  />
      </div>
    </div>
  );
};

export default ItemQuantity;
